// import Router from "@/router";
import { EventBus } from "@saas/components/src/utils/event-bus";
import { getCourseInfo } from "@saas/service-api/src/product-details";
import { handleImageUrl } from "@saas/components";
import {
  CONV_TYPE,
  IM_ORG_ROLE,
  MESSAGE_TYPE,
  CUSTOM_MSG_SOURCE,
} from "@saas/components/src/utils/im/constants";
import { getWorkList } from "@saas/service-api/src/course";
import { Message } from "element-ui";

const defaultDownloadPath = ({ date, conv_id }) => {
  let pathSep = window.pathSep ?? "/";
  return `${window.chatDownLoadDir}${conv_id}${pathSep}${date}${pathSep}`;
};

const getTime = (item) => {
  if (item) {
    const { message_server_time, message_client_time } = item;
    return message_server_time === 0
      ? message_client_time
      : message_server_time;
  }
  return 0;
};
const sortByPindAndTime = (conversationList = []) => {
  // const pinnedConversation = conversationList.filter(
  //   (item) => item.conv_is_pinned
  // );
  // const normalConversation = conversationList.filter(
  //   (item) => !item.conv_is_pinned
  // );
  // const sortPined = pinnedConversation.sort(
  //   (pre, next) =>
  //     (next.conv_is_has_draft
  //       ? next.conv_draft.draft_edit_time
  //       : getTime(next.conv_last_msg)) -
  //     (pre.conv_is_has_draft
  //       ? pre.conv_draft.draft_edit_time
  //       : getTime(pre.conv_last_msg))
  // );
  const sortPined = [];
  const sortNormal = conversationList.sort(
    (pre, next) =>
      (next.conv_is_has_draft
        ? next.conv_draft.draft_edit_time
        : getTime(next.conv_last_msg)) -
      (pre.conv_is_has_draft
        ? pre.conv_draft.draft_edit_time
        : getTime(pre.conv_last_msg))
  );
  return [...sortPined, ...sortNormal];
};
// 过滤掉不是邀请人的群组提示的信息
const filterSetAdminMessage = (list = []) => {
  try {
    const listCopy = JSON.parse(JSON.stringify(list));
    console.log("listcopy>>>>>>", listCopy);
    const res = listCopy.filter((item) => {
      if (
        item.message_elem_array &&
        item.message_elem_array[0] &&
        item.message_elem_array[0].group_tips_elem_tip_type
      ) {
        return [1, 4].includes(
          item.message_elem_array[0].group_tips_elem_tip_type
        );
      } else {
        return true;
      }
    });
    console.log(res, "res---filterSetAdminMessage");

    res.forEach((msg) => {
      // 自定义消息
      if (
        msg?.message_elem_array?.length &&
        msg.message_elem_array[0].elem_type === MESSAGE_TYPE.CUSTOM &&
        msg.message &&
        typeof msg.message === "string"
      ) {
        msg.message = JSON.parse(msg.message);
        let { msg_source, cover_url } = msg.message;
        msg.custom_msg_source = msg_source;
        switch (msg_source) {
          case CUSTOM_MSG_SOURCE.NOTICE:
            let { send_at, avatar, nickname } = msg;
            msg.message = {
              ...msg.message,
              updated_at: send_at,
              avatar,
              nickname,
            };
            break;
          case CUSTOM_MSG_SOURCE.LESSON_INFO:
            if (cover_url) {
              msg.message.cover_url =
                handleImageUrl(cover_url) + "?imageView2/0/w/100";
            }
            break;
          default:
            break;
        }
      }

      // 添加角色
      // || msg.message_sender
      if (msg.user_id) {
        let user_id = msg.user_id;
        let members = state.currentGroupmembers.filter((member) => {
          return member.group_member_info_identifier === user_id;
        });
        if (members.length) {
          let { role, color, user_profile_face_url } = members[0];
          msg.orgRoleText = role;
          msg.orgRoleColor = color;
        }
      }
    });

    return res;
  } catch (error) {
    console.log(error);

    return [];
  }
};
// 会话列表处理,
const dealConlist = (list = []) => {
  const data = JSON.parse(JSON.stringify(list));
  data.forEach((item) => {
    // 处理群聊-activeTab
    if (item.conv_type === CONV_TYPE.GROUP && !item.activeTab) {
      item.activeTab = "groupChat";
    }
    const lastMsg = item.conv_last_msg || {};
    if (lastMsg.message_status === 6) {
      // 处理已撤回
      if (lastMsg.message_is_from_self) {
        lastMsg.message_elem_array[0].elem_type = 0;
        lastMsg.message_elem_array[0].text_elem_content = "你 撤回一条消息";
      } else {
        lastMsg.message_elem_array[0].elem_type = 0;
        lastMsg.message_elem_array[0].text_elem_content =
          lastMsg.message_sender_profile?.user_profile_nick_name +
          "撤回了一条消息";
      }
      item.conv_last_msg = lastMsg;
    }
  });
  return data;
};
const handleCourseInfo = (item) => {
  let { org_id, org_logo, org_name, id, course_type } = item;
  let isLiving = false;
  // let liveLesson = [];
  // 筛选出今日直播课
  let todayLiveLesson = [];
  if (item?.unit_list?.length) {
    const unitList = item.unit_list;
    let todayTime = new Date().setHours(0, 0, 0, 0) / 1000;
    let tomorrowTime = todayTime + 24 * 60 * 60;
    unitList.forEach((unit) => {
      (unit.lesson_list || []).forEach((lesson) => {
        // 直播课
        if (lesson.lesson_type === 2) {
          let {
            live_start_time,
            live_end_time,
            room_start_time,
            room_end_time,
            record_url,
          } = lesson;

          // 处理直播间状态
          if (room_start_time > 0 && !room_end_time) {
            // 上课中
            lesson.roomStatus = 2;
            if (!isLiving) {
              isLiving = lesson;
            }
          } else if (room_end_time > 0) {
            // 已下课
            lesson.roomStatus = 3;
          } else {
            let now = new Date().getTime();
            if (live_end_time * 1000 < now) {
              // 已过上课时间
              lesson.roomStatus = 4;
            } else {
              // 未开始
              lesson.roomStatus = 1;
            }
          }
          if (record_url) {
            // 观看视频
            lesson.liveStatus = 1;
          } else if (lesson.roomStatus === 3) {
            // 回放生成中
            lesson.liveStatus = 2;
          }
          if (live_start_time >= todayTime && live_end_time < tomorrowTime) {
            todayLiveLesson.push(lesson);
          }
          // liveLesson.push(lesson);
        }
      });
    });
  }
  return {
    // ...item,
    // liveLesson,
    todayLiveLesson,
    isLiving,
    org_id,
    org_logo: handleImageUrl(org_logo) + "?imageView2/0/w/100",
    org_name,
    id,
    course_type,
  };
};

const state = {
  unreadCount: 0,
  appId: "",
  conversationList: [],
  messageList: [],
  currentConversation: {},
  // 用户在群里的信息
  userinfoAtGroup: {},
  // 通过sdk获取的最近的100条消息列表，会merge到messageList
  messageListBySDK: [],
  // 当前群成员信息
  currentGroupmembers: [],
  // 当前课程信息
  currentCourseInfo: {},
  // 当前会话下载文件列表
  convDownloadedFileMap: {},
  downloadInfo: {
    downloadingIds: {},
    downloadProgress: {},
    downloadSpeed: {},
    downLoadItems: {},
  },
  // 当前会话文件总数
  currentConvFileCount: 0,
  homeworkList: [], //作业列表
  tobeDone: 0, //待做作业
};
const getters = {
  userRoleAtGroup: (state) => {
    return state.userinfoAtGroup.group_member_info_member_role;
  },
  userIsAdmin: (state) => {
    return [400, 300].includes(
      state?.userinfoAtGroup?.group_member_info_member_role
    );
  },
};
const mutations = {
  setHomeworkList(state, data) {
    state.homeworkList = data;
  },
  setTobeDone(state, data) {
    state.tobeDone = data;
  },
  setDownloadInfo(state, obj) {
    state.downloadInfo = obj;
  },
  setConvDownloadedFileMap: (state, obj) => {
    if (obj?.fileDateList?.length || obj.update) {
      obj.fileDateList.forEach((date) => {
        const files = window.getFileListByDir({
          dirPath: defaultDownloadPath({
            date,
            conv_id: state.currentConversation.conv_id,
          }),
        });
        state.convDownloadedFileMap[obj.fileDateList] = files;
      });
    } else {
      state.convDownloadedFileMap = {};
      state.downloadInfo = {
        downloadingIds: {},
        downloadProgress: {},
        downloadSpeed: {},
        downLoadItems: {},
      };
    }
    console.log(
      state.convDownloadedFileMap,
      "convDownloadedFileMap",
      defaultDownloadPath
    );
  },
  setCurrentCourseInfo: (state, obj) => {
    state.currentCourseInfo = obj || {};
  },
  setCurrentGroupmembers(state, data) {
    state.currentGroupmembers = data;
  },
  setUserinfoAtGroup(state, data) {
    state.userinfoAtGroup = data;
  },
  setUnReadCount(state, data) {
    state.unreadCount = data;
    console.log(data, "unreadCount===");
  },
  setAppId(state, data) {
    state.appId = data;
  },
  // 设置当前会话
  setCurrentConversation(state, data) {
    state.currentConversation = data;
    console.log(
      // sortByPindAndTime(data),
      "state.currentConversation==========="
    );
  },
  // 更新当前会话-文件总数
  setCurrentConvFileCount(state, data) {
    state.currentConvFileCount = data;
  },
  // 设置会话列表
  setConversationList(state, data = []) {
    // 会话按是否置顶、时间排序
    const listCopy = [...state.conversationList];
    for (let i = 0; i < data.length; i++) {
      const { conv_id } = data[i];
      // 不处理显示admin消息
      if (conv_id === "administrator") {
        continue;
      }
      const conv_index = listCopy.findIndex((item) => {
        return item.conv_id === conv_id;
      });
      if (conv_index > -1) {
        // 存在，直接更新
        listCopy[conv_index] = {
          ...listCopy[conv_index],
          ...data[i],
        };
      } else {
        // 不存在，添加
        listCopy.unshift(data[i]);
      }
      console.log(listCopy.length);
    }
    let list = sortByPindAndTime(listCopy);
    // 更新当前会话
    const currentCon = list.find((item) => {
      return item.conv_id === state.currentConversation.conv_id;
    });
    if (currentCon) {
      const activeTab = state.currentConversation?.activeTab;
      if (activeTab) {
        currentCon.activeTab = activeTab;
      }
      state.currentConversation = currentCon;
    }
    state.conversationList = dealConlist(list);
  },
  // 替换会话列表
  replaceConversationList(state, data = []) {
    let list = sortByPindAndTime(data);
    // 更新当前会话
    const currentCon = list.find((item) => {
      return item.conv_id === state.currentConversation.conv_id;
    });
    if (currentCon) {
      state.currentConversation = currentCon;
    }
    state.conversationList = dealConlist(list);
  },
  // 替换消息列表
  replaceMessageList(state, data) {
    state.messageList = filterSetAdminMessage(data);
  },
  // 新增消息
  addMessage(state, data) {
    try {
      let haveGroupMemeberTips = false;
      data.forEach((item) => {
        const messageElemArray = item.message_elem_array[0];
        if (messageElemArray.elem_type === 3) {
          const customData = JSON.parse(messageElemArray.custom_elem_data);
          let { msg_source } = customData;
          switch (msg_source) {
            case CUSTOM_MSG_SOURCE.FILE:
              // 代表素材库 文件
              item.message_elem_array[0].elem_type = 4;
              item.message_elem_array[0].file_elem_url = customData.url_path;
              item.message_elem_array[0].file_elem_file_name =
                customData.file_name;
              item.message_elem_array[0].file_elem_file_size =
                customData.file_size;
              break;
            case CUSTOM_MSG_SOURCE.NOTICE:
              // 更新右下角公告
              EventBus.$emit("refresh-notice", item.message_conv_id);
              let { user_profile_face_url, user_profile_nick_name } =
                item?.message_sender_profile || {};
              item.message = {
                ...customData,
                updated_at: item.message_client_time,
                avatar: user_profile_face_url,
                nickname: user_profile_nick_name,
              };
              break;
            case CUSTOM_MSG_SOURCE.LESSON_INFO:
              item.message = {
                ...customData,
                cover_url:
                  handleImageUrl(customData.cover_url) + "?imageView2/0/w/100",
                roomStatus: 1,
              };
              break;
            default:
              break;
          }
        }
        if (!haveGroupMemeberTips) {
          // admin发送的文本消息（学生进群） || 群系统消息
          if (
            (item.message_sender === "administrator" &&
              messageElemArray.elem_type === 0) ||
            (messageElemArray.elem_type === MESSAGE_TYPE.GROUP_TIPS &&
              [1, 2, 3, 4, 5].includes(
                messageElemArray.group_tips_elem_tip_type
              ))
          ) {
            haveGroupMemeberTips = true;
          }
        }
      });
      state.messageList = filterSetAdminMessage([
        ...state.messageList,
        ...data,
      ]);
      if (haveGroupMemeberTips) {
        // 更新群成员列表
        EventBus.$emit(
          "refreshMemberInfoList",
          state.currentConversation.conv_id
        );
      }
    } catch (error) {
      console.log(error);
    }
  },
  // 撤回消息
  revokeMessage(state, data) {
    const list = JSON.parse(JSON.stringify(state.messageList));
    const convList = JSON.parse(JSON.stringify(state.conversationList));
    const index = list.findIndex(
      (item) => item.message_msg_id === data.message_msg_id
    );
    if (index > -1) {
      list[index].message_status = 6;
    }
    // convList.forEach((item) => {
    //   if (item.conv_last_msg.message_msg_id === data.message_msg_id) {
    //     const isSelf = data.message_locator_is_self;
    //     const nickname = isSelf ? "你" : data.message_revoker_nick_name;
    //     item.conv_last_msg.message_elem_array[0].text_elem_content =
    //       nickname + " 撤回一条消息";
    //   }
    // });
    state.conversationList = dealConlist(convList);
    state.messageList = filterSetAdminMessage(list);
  },
  updateMessage(state, data = []) {
    const list = JSON.parse(JSON.stringify(state.messageList));
    data.forEach((item) => {
      const index = list.findIndex(
        (msg) => msg.message_msg_id === item.message_msg_id
      );
      if (index > -1) {
        list[index] = item;
      }
    });
    state.messageList = filterSetAdminMessage(list);
  },
  // 更新消息状态
  updateMessageStatus(state, data) {
    const list = JSON.parse(JSON.stringify(state.messageList));
    data.forEach((item) => {
      const index = list.findIndex(
        (msg) => msg.message_msg_id === item.message_msg_id
      );
      if (index > -1) {
        list[index].message_status = item.message_status;
      }
    });
    state.messageList = filterSetAdminMessage(list);
  },
  // 移除消息
  removeMessage(state, msg_id) {
    state.messageList = state.messageList.filter(
      (msg) => msg.message_msg_id !== msg_id
    );
  },
  setMessageListBySDK(state, data) {
    state.messageListBySDK = data || [];
  },
  updateConvIsPinned(state, data) {
    let { conv_id, conv_is_pinned } = data;
    if (conv_id) {
      let covItem = state.conversationList.filter((cov) => {
        return cov.conv_id === conv_id;
      })[0];
      if (covItem) {
        covItem.conv_is_pinned = conv_is_pinned;
      }
    }
    state.conversationList = [...state.conversationList];
  },
};

const actions = {
  apiGetCourseInfo({ commit, state }, conv_id) {
    let params = {
      course_id: conv_id,
    };
    getCourseInfo(params).then((res) => {
      if (res.code === 1) {
        commit("setCurrentCourseInfo", handleCourseInfo(res.data || {}));
      }
    });
  },
  // 获取作业管理列表
  apiGetWorkList({ commit, state }, params) {
    let { course_id, work_warn_state } = params;
    getWorkList({
      course_id,
      work_warn_state,
    })
      .then((res) => {
        const { code, data, message } = res;
        if (code === 1) {
          let tobeDone = 0;
          let homeworkList = (data || []).map((item) => {
            let { work_end_time, work_info = {} } = item;
            let { status } = work_info;
            if (!status || status === 1) {
              // 未提交
              let now = new Date().getTime();
              if (work_end_time && work_end_time * 1000 < now) {
                item.isExpired = true;
                item.statusText = "已过期";
              } else {
                item.statusText = "未完成";
                tobeDone++;
              }
            } else {
              item.statusText = "已完成";
            }
            return {
              ...item,
            };
          });
          commit("setHomeworkList", homeworkList);
          commit("setTobeDone", tobeDone);
        } else {
          Message({
            message,
            type: "error",
          });
          commit("setHomeworkList", []);
          commit("setTobeDone", 0);
        }
      })
      .catch(() => {
        commit("setHomeworkList", []);
        commit("setTobeDone", 0);
      });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
